import { Flex, Skeleton } from "@chakra-ui/react";

function SkeletonForm() {
  return (
    <Flex mt="16px" flexDir="column" gap="16px">
      <Skeleton h="35px" w="100%" />
      <Flex gap="16px">
        <Flex flex={1}>
          <Skeleton h="35px" w="100%" />
        </Flex>
        <Flex flex={1}>
          <Skeleton h="35px" w="100%" />
        </Flex>
      </Flex>
      <Flex gap="16px">
        <Flex flex={1}>
          <Skeleton h="35px" w="100%" />
        </Flex>
        <Flex flex={1}>
          <Skeleton h="35px" w="100%" />
        </Flex>
      </Flex>
    </Flex>
  );
}

export default SkeletonForm;
